import { render, staticRenderFns } from "./rankTable.vue?vue&type=template&id=ecedce92&scoped=true"
import script from "./rankTable.vue?vue&type=script&lang=js"
export * from "./rankTable.vue?vue&type=script&lang=js"
import style0 from "./rankTable.vue?vue&type=style&index=0&id=ecedce92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecedce92",
  null
  
)

export default component.exports